import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import MainIssueList from "./components/MainIssueList";
import IssueDetailView from "./components/IssueDetailView";
import Test from "./components/wiki/test";
import Outlet from "./components/Outlet";
import Editorial from "./components/Editorial";
import Intro from "./components/PlatformIntro";
import Contact from "./components/Contact";
import OutletDetail from "./components/OutletDetail";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./App.css";

// 스크롤 위치를 관리하는 컴포넌트
function ScrollToTop() {
  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

function App() {
  const [currentPage, setCurrentPage] = React.useState(1);
  React.useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const flag = sessionStorage.getItem("struggle:refreshed-once");
      if (!flag) {
        sessionStorage.setItem("struggle:refreshed-once", "true");
        window.location.reload();
      }
    } catch {
      /* ignore storage errors */
    }
  }, []);

  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Header />
        <div className="content-wrap">
          <Routes>
            <Route
              path="/"
              element={
                <MainIssueList
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              }
            />
            <Route path="/issue/:issueId" element={<IssueDetailView />} />
            <Route path="/outlet" element={<Outlet />} />
            <Route path="/outlet/:outletName" element={<OutletDetail />} />
            <Route path="/editorial" element={<Editorial />} />
            <Route path="/about" element={<Intro />} />
            <Route path="/contact" element={<Contact />} />
            {/* <Route path="/sample" element={<Sample />} /> */}
          </Routes>
        </div>
        <Footer />
      </Router>
      <Analytics />
    </div>
  );
}

export default App;
